import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d9db2516")

_pushScopeId("data-v-d9db2516")
const _hoisted_1 = {
  "data-testid": "pickup-detail-summary-row",
  class: "flex w-full gap-3"
}
const _hoisted_2 = {
  key: 0,
  "data-testid": "pickup-detail-summary-skeleton",
  class: "flex w-full gap-3"
}
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = {
  "data-testid": "pickup-detail-summary-card-total-request",
  class: "pickup-summary-card flex-1"
}
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_7 = {
  "data-testid": "pickup-detail-summary-metrics-total-request",
  class: "mt-2 flex items-baseline gap-1 font-medium text-black-lp-300"
}
const _hoisted_8 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_9 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_10 = { class: "mt-auto pt-4 text-xs text-black-lp-200 font-medium" }
const _hoisted_11 = {
  "data-testid": "pickup-detail-summary-card-total-pickup",
  class: "pickup-summary-card flex-1"
}
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_14 = {
  "data-testid": "pickup-detail-summary-metrics-total-pickup",
  class: "mt-2 flex items-baseline gap-1 font-medium text-black-lp-300"
}
const _hoisted_15 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_16 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_17 = {
  key: 0,
  "data-testid": "pickup-detail-summary-additional-koli",
  class: "mt-1 inline-flex w-max items-center rounded-full bg-gray-lp-200 px-2 py-1 text-xs text-black-lp-300"
}
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "mt-auto pt-2 text-xs text-black-lp-200 font-medium" }
const _hoisted_20 = {
  "data-testid": "pickup-detail-summary-card-agent-hub",
  class: "pickup-summary-card flex-1"
}
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_23 = {
  "data-testid": "pickup-detail-summary-metrics-agent-hub",
  class: "mt-2 flex items-baseline gap-1 font-medium text-black-lp-300"
}
const _hoisted_24 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_25 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_26 = { class: "mt-auto pt-2 text-xs text-black-lp-200 font-medium" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (index) => {
            return _createVNode("div", {
              key: index,
              class: "pickup-summary-card flex-1"
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Skeleton, {
                  height: "1rem",
                  width: "1rem"
                }),
                _createVNode(_component_Skeleton, {
                  height: "1rem",
                  width: "7rem"
                })
              ]),
              _createVNode(_component_Skeleton, {
                class: "mt-3",
                height: "1.25rem",
                width: "9rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "mt-3",
                height: "0.75rem",
                width: "11rem"
              })
            ])
          }), 64))
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Icons, { name: "pickup-total-request" }),
              _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("pickup.detail.summary.totalRequest.title")), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, [
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.totalRequestKoli), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.koliUnit")) + " • ", 1),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.totalRequestWeight), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.weightUnit")), 1)
              ])
            ]),
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.totalRequestSchedule), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Icons, { name: "pickup-total-pickup" }),
              _createVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("pickup.detail.summary.totalPickup.title")), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("span", null, [
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.totalPickupStt), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.sttUnit")) + " (" + _toDisplayString(_ctx.totalPickupKoli) + " " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.koliUnit")) + ") • ", 1),
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.totalPickupWeight), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.weightUnit")), 1)
              ])
            ]),
            (_ctx.showTotalPickupAdditionalKoli)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("pickup.detail.summary.shared.additionalLabel")) + " ", 1),
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.totalPickup.additionalKoli), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.koliUnit")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.totalPickupSchedule), 1)
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_Icons, { name: "pickup-agent-hub" }),
              _createVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t("pickup.detail.summary.agentHub.title")), 1)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("span", null, [
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.agentHubStt), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.sttUnit")) + " (" + _toDisplayString(_ctx.agentHubKoli) + " " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.koliUnit")) + ") • ", 1),
                _createVNode("span", _hoisted_25, _toDisplayString(_ctx.agentHubWeight), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.detail.summary.shared.weightUnit")), 1)
              ])
            ]),
            _createVNode("p", _hoisted_26, _toDisplayString(_ctx.agentHubSchedule), 1)
          ])
        ], 64))
  ]))
})